import { IconProps } from "@/@types/general";

const SuccessIcon = ({ className }: IconProps) => {
  return (
    <svg
      width="6.5rem"
      height="6.5rem"
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g filter="url(#filter0_d_315_15327)">
        <path
          d="M52 82C74.0914 82 92 64.0914 92 42C92 19.9086 74.0914 2 52 2C29.9086 2 12 19.9086 12 42C12 64.0914 29.9086 82 52 82Z"
          fill="#FF5708"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.1342 57.9139L30.6887 45.6639C29.1218 43.9868 29.2117 41.3334 30.8888 39.7665C32.5659 38.1995 35.2193 38.2897 36.7862 39.9666L45.6148 49.4156L59.5892 36.3588C59.7148 36.2413 59.8462 36.1336 59.982 36.0345L66.5536 29.8946C68.2307 28.3277 70.8843 28.4179 72.451 30.095C74.018 31.7718 73.9278 34.4254 72.2509 35.9924L52.1795 54.7457L52.1581 54.7228L45.2151 61.2099L42.1342 57.9139Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_315_15327"
          x="0"
          y="0"
          width="104"
          height="104"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.294118 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_315_15327" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_315_15327" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default SuccessIcon;
